import { createSelector } from 'redux-bundler';
import userInitials from 'utils/initials';

/*
  ** Returns an OBJECT **

  Returns and object containing firstName, lastName, and icon
  for use in updating user profile in the API
*/

export const selectUserProfile = createSelector(
  'selectUser',
  ({ firstName, icon, lastName, phoneNumber }) => {
    return { firstName, icon, lastName, phoneNumber };
  },
);

export const selectFullUser = createSelector('selectUser', (user) => {
  const fullName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
  const initials = userInitials({ maxInitials: 2, name: fullName });
  return { ...user, fullName, initials };
});
